module.exports = __webpack_public_path__ + "static/media/bubi.f56b1f91.svg";